import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '@app/auth/services/auth-guard.service';
import { EnterpriseOptionType } from '@app/core/interfaces/enterprise-option-type';
import { SecurityPermissionName } from '@app/core/models/permission';
import { MeetingPageComponent } from '@business/meeting/components/meeting-page/meeting-page.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        canActivate: [AuthGuardService],
        component: MeetingPageComponent,
        data: {
          allowedPermissions: [
            SecurityPermissionName.VIEW_CONFERENCE,
            SecurityPermissionName.VIEW_ANY_CONFERENCE,
          ],
          hasEnterpriseOption: EnterpriseOptionType.CollaborationFeatures,
        },
        path: '',
      },
    ]),
  ],
  exports: [RouterModule],
})
export class MeetingRoutingModule {}
